import React, { useEffect, useState } from "react";
import { TeachingBubble, IButtonProps } from "@fluentui/react";
import { LightbulbIcon } from "@fluentui/react-icons-mdl2";
import { getContractMapGuideTips, getContractMapGuideTargetId } from "@/screen/Map/contractMapGuideTips";
import * as S from "@/screen/Map/Components/ContractMapGuideBubbleStyles";

export interface ContractMapGuideBubbleProps
{
    isOpen: boolean;
    stepKey: string;
    onDismiss: () => void;
    targetId?: string;
}

export const ContractMapGuideBubble: React.FC<ContractMapGuideBubbleProps> = (props) =>
{
    const {isOpen, stepKey, onDismiss, targetId = getContractMapGuideTargetId(stepKey)} = props;

    const tips = getContractMapGuideTips(stepKey);
    const [activeTipIndex, setActiveTipIndex] = useState<number>(0);
    const lastTipIndex = Math.max(tips.length - 1, 0);

    useEffect(() =>
    {
        setActiveTipIndex(0);
    }, [stepKey, isOpen]);

    const primaryButtonProps: IButtonProps = React.useMemo(() =>
    (
        {
            children: "Siguiente",
            disabled: activeTipIndex === lastTipIndex,
            onClick: () => setActiveTipIndex((prevState) => prevState + 1),
            className: "mini-primary-button"
        }),
        [activeTipIndex, lastTipIndex],
    );

    const secondaryButtonProps: IButtonProps = React.useMemo(() =>
    (
        {
            children: "Anterior",
            disabled: activeTipIndex === 0,
            onClick: () => setActiveTipIndex((prevState) => prevState - 1),
            className: "mini-primary-button"
        }),
        [activeTipIndex],
    );

    const handleDismiss = () =>
    {
        setActiveTipIndex(0);
        onDismiss();
    };

    if(!isOpen || tips.length === 0)
    {
        return null;
    }

    return(
        <TeachingBubble
            target={`#${targetId}`}
            primaryButtonProps={primaryButtonProps}
            secondaryButtonProps={secondaryButtonProps}
            footerContent={`${activeTipIndex + 1} de ${tips.length}`}
            onDismiss={handleDismiss}
            calloutProps={{ backgroundColor: "white !important", style: { color: "red" } }}
            hasCloseButton={true}
            closeButtonAriaLabel="Cerrar"
            styles={S.GuideBubbleFluentStyles}
        >
            <S.GuideHeader>
                <LightbulbIcon style={{color: "gold", width: "20px", height: "20px"}} />
                <S.GuideHeaderTitle>Guía</S.GuideHeaderTitle>
            </S.GuideHeader>
            {tips.map((tip, index) =>
            (
                <S.GuideTipStep key={tip.title} $isVisible={activeTipIndex === index}>
                    <S.GuideTipImage src={tip.imageSrc} alt="" />
                    <S.GuideTipTitle>{tip.title}</S.GuideTipTitle>
                    {tip.paragraphs.map((paragraph) =>
                    (
                        <S.GuideTipParagraph key={paragraph}>
                            {paragraph}
                        </S.GuideTipParagraph>
                    ))}
                </S.GuideTipStep>
            ))}
        </TeachingBubble>
    );
};